import { t } from "i18next"
import { z } from "zod"
import { stringRequired, textAreaDefaultMaxLength } from "@/models/common"
import {
  Aim,
  ConditionStage,
  Language,
  Occurrence,
  PrescriptionRepetition,
  ReasonForPhysiotherapy,
  Side,
  TreatmentUnitPerDay,
} from "@/types/__generated__/union-types"

export const PhysiotherapySchema = z.object({
  language: z.custom<Language>(),
  healthcareProviderId: z.string().optional(),
  treatmentUnit: stringRequired.refine((value) => Number(value) >= 1 && Number(value) <= 99, {
    message: t("common.fieldErrorList.valueInRange", { min: 1, max: 99 }),
  }),
  prescriptionRepetition: z.custom<PrescriptionRepetition>(),
  aims: z.array(z.custom<Aim>()).min(1, {
    message: "common.fieldErrorList.requiredField",
  }),
  reason: z.custom<ReasonForPhysiotherapy>(),
  diagnosisCode: stringRequired,
  sides: z.array(z.custom<Side>()),
  leadingSymptom: z.string().max(200, { message: t("common.fieldErrorList.characterLimit") }),
  trigger: z.string().max(200, { message: t("common.fieldErrorList.characterLimit") }),
  duration: z.string().max(200, { message: t("common.fieldErrorList.characterLimit") }),
  conditionStage: z.custom<ConditionStage>(),
  internalNote: z.string().max(textAreaDefaultMaxLength, { message: t("common.fieldErrorList.characterLimit") }),
  allergies: z.array(z.string()),
  conditions: z.array(z.string()),
  medicationIds: z.array(z.string()),
  treatmentUnitPerDay: z.custom<TreatmentUnitPerDay>(),
  isHomeTreatment: z.boolean(),
  occurrence: z.custom<Occurrence>(),
})

export type Physiotherapy = z.infer<typeof PhysiotherapySchema>
